@if (isVisible()) {
  <ds-details [summary]="header()" data-test-id="ai-testing-progress-details">
    <div class="table-responsive">
      <table class="table" data-test-id="ai-testing-progress-table">
        <caption class="visuallyhidden">
          {{
            'ai_testing_progress_table_caption' | translate
          }}
        </caption>
        <thead>
          <tr>
            <th scope="col" class="text-start">{{ 'ai_testing_progress_column_name' | translate }}</th>
            <th scope="col" class="text-start">{{ 'status' | translate }}</th>
            <th scope="col" class="text-start">{{ 'reason' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (row of pageRows(); track row.pageId) {
            <tr data-test-id="ai-testing-progress-row">
              <td class="text-break">{{ row.label }}</td>
              <td>
                <ds-chip [text]="getStatusText(row.status)" [colorVariant]="getChipVariant(row.status)"></ds-chip>
              </td>
              <td class="text-break" data-test-id="ai-testing-progress-reason">
                @if (row.status === AiTestingPageDisplayStatus.failed) {
                  {{ row.error || ('ai_testing_page_error_generic' | translate) }}
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    @if (totalRows() > pageSize) {
      <ds-pagination
        [ariaLabel]="'ai_testing_progress_pagination_label' | translate"
        [page]="pagination().currentPage"
        [pageSize]="pageSize"
        [collectionSize]="totalRows()"
        (pageChange)="onPageChange($event)"
      ></ds-pagination>
    }
  </ds-details>
  <div class="visuallyhidden" role="status" aria-live="polite" data-test-id="ai-testing-progress-live-region">
    {{ announcement() }}
  </div>
}
